export class StopAreaHelper {
  public static getNameWithoutMunicipality(value: string | undefined): string {
    if (!value) return '';
    const lastIndex = value.lastIndexOf(',');
    if (lastIndex === -1) {
      return value;
    }
    return value.substring(0, lastIndex);
  }
}
